// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textInput_lzup3 {
  border: 1px solid #D2D2D2;
  padding : 6px 8px;
}

.textInput_lzup3:focus {
  outline:none;
  border-color: rgba(75, 130, 252, 1.0);
}

.textInput_lzup3[data-error=true] {
  border-color: #EE5555;
}

.textInput_lzup3.textInput-small_keNJw {
  font-size: 11px;
  padding: 5px 8px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/TextInput.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".textInput {\n  border: 1px solid #D2D2D2;\n  padding : 6px 8px;\n}\n\n.textInput:focus {\n  outline:none;\n  border-color: rgba(75, 130, 252, 1.0);\n}\n\n.textInput[data-error=true] {\n  border-color: #EE5555;\n}\n\n.textInput.textInput-small {\n  font-size: 11px;\n  padding: 5px 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInput": `textInput_lzup3`,
	"textInput-small": `textInput-small_keNJw`
};
export default ___CSS_LOADER_EXPORT___;
